import { useEffect, useState } from 'react'
import { HOME_CATALOG_COLUMNS, HOME_CATALOG_ROWS } from '../constants/home'

function catalogColumns(): number {
  if (window.matchMedia(`(min-width: ${HOME_CATALOG_COLUMNS.desktopMinPx}px)`).matches) {
    return HOME_CATALOG_COLUMNS.desktop
  }
  if (window.matchMedia(`(min-width: ${HOME_CATALOG_COLUMNS.tabletMinPx}px)`).matches) {
    return HOME_CATALOG_COLUMNS.tablet
  }
  return HOME_CATALOG_COLUMNS.mobile
}

export function useHomeCatalogLimit(): number {
  const [columns, setColumns] = useState(catalogColumns)

  useEffect(() => {
    const desktop = window.matchMedia(
      `(min-width: ${HOME_CATALOG_COLUMNS.desktopMinPx}px)`,
    )
    const tablet = window.matchMedia(
      `(min-width: ${HOME_CATALOG_COLUMNS.tabletMinPx}px)`,
    )
    const apply = () => setColumns(catalogColumns())
    apply()
    desktop.addEventListener('change', apply)
    tablet.addEventListener('change', apply)
    return () => {
      desktop.removeEventListener('change', apply)
      tablet.removeEventListener('change', apply)
    }
  }, [])

  return columns * HOME_CATALOG_ROWS
}
